module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/227598e595f11ea77afb97fdc79b769c.gif";